// extracted by mini-css-extract-plugin
module.exports = {"paymentSegment":"PaymentType-PaymentSegment-module--payment-segment--bKO4J","active":"PaymentType-PaymentSegment-module--active--3CoDP"};